export default __webpack_public_path__ + "static/media/1_0142.58fea2ef.webp";